import { Controller } from "@hotwired/stimulus"

// Adds a class when elements scroll into view (for fade-in + slide-up animation)
export default class extends Controller {
  static targets = ["item"]

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersection(entries),
      {
        rootMargin: "0px 0px -50px 0px",
        threshold: 0
      }
    )

    this.itemTargets.forEach((el) => this.observer.observe(el))
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("scroll-reveal--visible")
        this.observer.unobserve(entry.target)
      }
    })
  }
}
